import { render } from "./ShowTicket.vue?vue&type=template&id=48bfd776"
import script from "./ShowTicket.vue?vue&type=script&lang=js"
export * from "./ShowTicket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__